
import { ServiceCategory } from '@/types/serviceTypes';

export const specialtyServicesCategory: ServiceCategory = {
  id: 'specialty-services',
  name: 'Specialty Services',
  icon: 'specialty',
  services: [
    {
      id: 'firewood',
      title: 'Firewood',
      description: 'Premium seasoned firewood services for your home or business, delivering quality wood for warmth and ambiance.',
      features: [
        'Seasoned hardwood',
        'Delivery services',
        'Custom volume options',
        'Stacking services available',
        'Mixed wood varieties'
      ],
      image: 'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'irrigation',
      title: 'Irrigation',
      description: 'Water-efficient irrigation systems designed, installed, and maintained to keep your landscape healthy while conserving resources.',
      features: [
        'System design and installation',
        'Smart controller technology',
        'Water conservation solutions',
        'Spring startup services',
        'Winterization programs'
      ],
      image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'power-washing',
      title: 'Power Washing',
      description: 'Revitalize your outdoor surfaces with our professional power washing services that safely remove dirt, grime, and stains.',
      features: [
        'Deck and patio cleaning',
        'Siding rejuvenation',
        'Walkway and driveway cleaning',
        'Fence brightening',
        'Safe, effective techniques'
      ],
      image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'snow-removal',
      title: 'Snow Removal',
      description: 'Dependable snow removal services keeping your property safe and accessible throughout the winter months in Fairfield County.',
      features: [
        '24/7 monitoring',
        'Prompt plowing',
        'Walkway clearing',
        'Ice management',
        'Commercial & residential service'
      ],
      image: 'https://images.unsplash.com/photo-1491002052546-bf38f186af56?q=80&w=2070&auto=format&fit=crop'
    }
  ]
};
